import { render, staticRenderFns } from "./BtnRetiradasProduto.vue?vue&type=template&id=3bd9adf1&"
import script from "./BtnRetiradasProduto.vue?vue&type=script&lang=js&"
export * from "./BtnRetiradasProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports